import { FormCheckBoxModel } from "../../common/types/FormCheckBoxModel";

export const erpLogoParameters: FormCheckBoxModel[] = [
    {
        value: "3",
        label: "Ödeme Fişi Entegrasyonu",
        formName: "paymentsyncCheckbox",
    },
    {
        value: "4",
        label: "Ödeme Sonrası Otomatik Aktarım",
        formName: "autoPaymentsyncChecked",
    },
    {
        value: "6",
        label: "Müşteri Kartı Entegrasyonu",
        formName: "customersyncChecked",
    },
    {
        value: "7",
        label: "Müşteri Bakiye Entegrasyonu",
        formName: "customerbalanceChecked",
    },
    {
        value: "8",
        label: "Durum",
        formName: "status",
    },
    {
        value: "9",
        label: "isTransactionItemCardHolderName",
        formName: "logoParams.isTransactionItemCardHolderName",
    },
    {
        value: "10",
        label: "affectRisk",
        formName: "logoParams.affectRisk",
    }
];